import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_CATEGORY_ENUM,
  ExceptionTrackingService,
  HttpRequestMethods,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { IDP_APP } from '../../constants/login-constant';
import { LoginModalEndpointsKeys } from '../../models/login-modal.enum';
import {
  ResetPasswordEmailLinkResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  ResetPasswordUserRequest,
  ResetPasswordUserResponse,
  ShowResetPasswordUserPayload
} from '../../models/reset-password-api.interface';
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordApiService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  getUserData = (
    payload: ResetPasswordUserRequest
  ): Observable<ResetPasswordUserResponse> =>
    new ApiBuilder<ResetPasswordUserRequest, ResetPasswordUserResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['FORGOT_LOGIN_BFF_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError.bind(this))
      .create();

  showResetPassword = (payload: ShowResetPasswordUserPayload) =>
    new ApiBuilder<
      ShowResetPasswordUserPayload,
      ResetPasswordEmailLinkResponse
    >(this.http, this.appConfig)
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['SHOW_RESET_PASSWORD_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError.bind(this))
      .create();

  sendResetPasswordEmailLink = (
    payload: { [key: string]: string } = {}
  ): Observable<ResetPasswordEmailLinkResponse> =>
    new ApiBuilder<{ [key: string]: string }, ResetPasswordEmailLinkResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['RESET_PASSWORD_EMAIL_LINK'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError.bind(this))
      .create();

  resetPassword = (
    payload: ResetPasswordRequest
  ): Observable<ResetPasswordResponse> =>
    new ApiBuilder<ResetPasswordRequest, ResetPasswordResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['RESET_PASSWORD'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError.bind(this))
      .create();

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: 'reset-password-api.service.ts',
      methodName: '_handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService?.track(
      `[${IDP_APP}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }
}
